<script>
    import model from "../../stores/modelStore";
    import { projectSettings } from "../../config";
	import { isValid } from "../../validation";
    import lookups from "../../stores/lookupStore";

    import Form from "../../components/Form.svelte";
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";
    import TextInput from "../../components/TextInput.svelte";
    import TextArea from "../../components/TextArea.svelte";
    import PageSection from "../../components/PageSection.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";
    import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
    import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

    import Treatments from "./components/Treatments.svelte";

    // props
    export let persistUrl = null;
    export let pageTitle = null;
    export let disabled = false;
    export let lastVisitedPage = null;

    let buttons = null;
    let treatments = [];

    // component state updating
    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

    const handleSubmit = async (e) => {
    	buttons.blockNext();

		let errors = [...isValid()];

		if (!errors.length) {
            processTreatments();

			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError)
			} else {
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
    };

    const processTreatments = () => {
        $model.treatments.length = 0;

        treatments.filter(t => t.checked).forEach(t => {
            $model.treatments.push({
                treatmentId: t.treatmentId,
                treatmentTypeId: t.treatmentTypeId,
                otherDetails: t.otherDetails,
                stillRequired: t.stillRequired,
            });
        });
    }

    const initialise = () => {
        $lookups.treatmentLookups.forEach(t => {
            let treatment = {
                checked: false,
                treatmentId: 0,
                treatmentTypeId: null,
                treatmentName: null,
                otherDetails: null,
                stillRequired: null,
            }

            treatment.treatmentTypeId = t.id;
            treatment.treatmentName = t.name;

            let treatmentIndex = $model.treatments.findIndex(_t => _t.treatmentTypeId == t.id);
            if (treatmentIndex >= 0) {
                treatment.checked = true;
                treatment.treatmentId = $model.treatments[treatmentIndex].treatmentId;
                treatment.otherDetails = $model.treatments[treatmentIndex].otherDetails;
                treatment.stillRequired = $model.treatments[treatmentIndex].stillRequired;
            }

            treatments.push(treatment);
        });

        treatments = [ ...treatments ];
    }

    initialise();
</script>


<PageSection>
	<Form {disabled} id="form-claim-details" on:submit={handleSubmit}>
        <FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Treatment Details</h1>
			</FormColumn>
		</FormRow>
	
		<hr class="primary" />

		<div class="confirmation-box-shadow">

            <Treatments {disabled} bind:treatments={treatments}>
            </Treatments>

        </div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"}
                    onprevious={processTreatments}/>
			</FormColumn>
		</FormRow>

	</Form>
</PageSection>

<style>

    .confirmation-box-shadow {
        border: 1px solid var(--color-soft);
        background-color: var(--color-white);
        box-shadow: var(--box-shadow-card);
        padding: 20px;
        margin-bottom: 26px;
    }

</style>
